import React from 'react';
import styled from 'styled-components';

const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  z-index: 1000;
  min-width: 150px;
`;

const SizeOption = styled.button`
  width: 100%;
  padding: 0.5rem 1rem;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  display: block;
  font-size: ${(props) => props.style?.fontSize};

  &:hover {
    background: #f3f4f6;
  }
`;

const TextSizeDropdown = ({ onSelect }) => {
  const sizes = [
    { label: 'Small', value: '1', size: '12px' },
    { label: 'Normal', value: '3', size: '16px' },
    { label: 'Large', value: '5', size: '20px' },
    { label: 'Huge', value: '7', size: '24px' },
  ];

  return (
    <DropdownContainer>
      {sizes.map((size) => (
        <SizeOption
          key={size.value}
          onClick={() => onSelect(size.value)}
          style={{ fontSize: size.size }}
        >
          {size.label}
        </SizeOption>
      ))}
    </DropdownContainer>
  );
};

export default TextSizeDropdown;
